<template>
  <div class="become-an-affiliate">
    <div id="content">
      <p class="explain">{{ $t('explain') }}</p>
      <div id="reward-lists">
        <p class="reward-rules-title">{{ $t('rewardRules') }}</p>
        <p v-for="(rule, index) in $t('rulesList')" class="rules-list" :key="index">
          <span class="index">{{ index + 1 }}</span>
          {{ rule }}
        </p>
      </div>

      <div id="affiliate-form">
        <p class="error-notice" v-if="alreadyApply">
          *
          <span v-if="commissionApplyStatus === 'pending'">{{ $t('notice.pending') }}</span>
          <span v-if="commissionApplyStatus === 'cancelled'">{{ $t('notice.cancelled') }}</span>
          <span v-if="commissionApplyStatus === 'complete'">{{ $t('notice.complete') }}</span>
          iplexservice@gmail.com
        </p>
        <p class="error-notice" v-show="user.id === 0">* {{ $t('notice.notLogin') }}</p>

        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <p class="input-name">* {{ $t('promotionPlatform') }}</p>
            <input autocomplete="off"
              type="text"
              name="promotionPlatform"
              v-model="platform"
              v-validate="'required'"
              @focus="platformBlur = false"
              @blur="platformBlur = true"
              :disabled="canNotApply"
              :class="{'danger-border': platformError}"
            />
            <p class="error-info">
              <span v-show="platformError">{{ errors.first('promotionPlatform') }}</span>
            </p>
          </div>
          <div class="col-xs-12 col-sm-6">
            <p class="input-name">* {{ $t('promotionMethod') }}</p>
            <input autocomplete="off"
              type="text"
              name="promotionMethod"
              v-model="type"
              v-validate="'required'"
              @focus="typeBlur = false"
              @blur="typeBlur = true"
              :disabled="canNotApply"
              :class="{'danger-border': typeError}"
            />
            <p class="error-info">
              <span v-show="typeError">{{ errors.first('promotionMethod') }}</span>
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <p class="input-name">* {{ $t('companyName') }}</p>
            <input autocomplete="off"
              type="text"
              name="companyName"
              v-model="companyName"
              v-validate="'required'"
              @focus="companyNameBlur = false"
              @blur="companyNameBlur = true"
              :disabled="canNotApply"
              :class="{'danger-border': companyNameError}"
            />
            <p class="error-info">
              <span v-show="companyNameError">{{ errors.first('companyName') }}</span>
            </p>
          </div>
          <div class="col-xs-12 col-sm-6">
            <p class="input-name">{{ $t('officialSite') }}</p>
            <input autocomplete="off" type="text" name="officialSite" v-model="address" :disabled="canNotApply" />
          </div>
        </div>

        <div class="explanation-box">
          <p class="input-name">{{ $t('explanation') }}</p>
          <textarea name="explanation" v-model="remarks" :disabled="canNotApply"></textarea>
          <transition name="notice">
            <span class="please-agree-policy" v-show="showNotice">{{ $t('pleaseAgreePolicy') }}</span>
          </transition>
        </div>

        <p :class="['affiliate-policy-box text-center', {'agree-policy': agreePolicy}]">
          <span class="circle-span disabled-span" v-if="canNotApply"></span>
          <span @click="changeAgreePolicyStatus" class="circle-span" v-else></span>
          <img src="/static/img/affiliate/agree_policy_2x.png" alt="agree affiliate policy" @click="changeAgreePolicyStatus" />
          <span>{{ $t('submitMeans') }}</span>
          <router-link to="affiliate-policy">{{ $t('affiliatePolicy') }}</router-link>
        </p>

        <button :class="['gradient-border-btn', {'disabled-btn': canNotApply}]" @click="becomeAnAffiliate" v-show="!loading">
          <span class="fill-bg"></span>
          <span>{{ $t('becomeAffiliate') }}</span>
        </button>

        <spinner :show="loading" class="spinner-component"></spinner>
      </div>
    </div>

    <become-affiliate-success-modal v-if="applySuccess"></become-affiliate-success-modal>
    <commission-apply-status-modal v-if="alreadyApply"></commission-apply-status-modal>
  </div>
</template>

<script>
import Spinner from '../../components/Spinner.vue';
import BecomeAffiliateSuccessModal from '../../components/becomeAffiliate/successModal/Index.vue';
import CommissionApplyStatusModal from '../../components/becomeAffiliate/statusModal/Index.vue';
import locales from './lang';
import { mapState } from 'vuex';

export default {
  name: 'become-an-affiliate-view',
  components: { Spinner, BecomeAffiliateSuccessModal, CommissionApplyStatusModal },
  data: function () {
    return {
      platform: '',
      platformBlur: true,
      type: '',
      typeBlur: true,
      companyName: '',
      companyNameBlur: true,
      address: '',
      remarks: '',
      loading: false,
      agreePolicy: false,
      showNotice: false,
      applySuccess: false
    };
  },
  locales,
  computed: {
    ...mapState({
      commissionApplyStatus: state => state.commission.commissionApplyStatus,
      user: state => state.user,
      notLogin: state => !state.user.id
    }),
    alreadyApply() {
      return (
        this.commissionApplyStatus === 'cancelled' || this.commissionApplyStatus === 'pending' || this.commissionApplyStatus === 'complete'
      );
    },
    canNotApply() {
      return this.alreadyApply || this.notLogin;
    },
    platformError() {
      return this.platformBlur && this.errors.has('promotionPlatform');
    },
    typeError() {
      return this.typeBlur && this.errors.has('promotionMethod');
    },
    companyNameError() {
      return this.companyNameBlur && this.errors.has('companyName');
    }
  },
  mounted() {
    this.$store.dispatch('getUserInformation');
    this.$store.dispatch('getCommissionApplyStatus');
  },
  methods: {
    changeAgreePolicyStatus() {
      this.agreePolicy = !this.agreePolicy;
    },
    becomeAnAffiliate() {
      if (this.canNotApply) return;
      if (!this.agreePolicy) {
        this.showNotice = !this.showNotice;
        return;
      }
      this.loading = true;
      this.$validator.validateAll().then(success => {
        if (!success) {
          this.loading = false;
          return;
        }
        this.$http
          .patch('api/commission/apply', {
            platform: this.platform,
            type: this.type,
            company_name: this.companyName,
            address: this.address,
            remarks: this.remarks
          })
          .then(
            response => {
              this.loading = false;
              if (response.data.code === 0) {
                this.applySuccess = true;
                this.$store.commit('setCommissionApplyStatus', response.data.data.status);
                this.$store.dispatch('getUserInformation');
              }
            },
            response => {
              this.loading = false;
            }
          );
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'become-an-affiliate';
</style>



// WEBPACK FOOTER //
// Index.vue?6c32085d